import React from "react";
import Textura from "../../media/TEXTURA-AZUL.png";

function CallToAction() {
  return (
    <div className="w-[1080px] h-[450px] relative border-solid border-4 border-primario rounded-30 overflow-hidden bg-yellow-3 mx-auto shadow-[-10px_10px_0px_0px_#0D2334]">
      {/* <img src={Textura} width={1080} className="absolute z-0 w-[1920px] h-[1080px] object-cover" alt="" /> */}
      <div className="w-full absolute z-10 flex flex-row h-full">
        <div className="w-1/2 flex flex-col justify-center items-center p-5 gap-5">
          <p className="text-2xl text-primario text-center">
            Convierte el inglés en una herramienta para tu trabajo, agenda un
            clase de cortecia con nostros.
          </p>
          <a
            className="py-3 px-10 font-Bebas bg-terciario text-primario text-4xl rounded-full " 
            href="#"
            target="_blank"
            rel="noopener noreferrer"
          >
            Agenda tu clase
          </a>
        </div>
        <div className="w-1/2 overflow-hidden rounded-l-30 bgs">
          <img
            className="object-cover w-full h-full"
            src="https://brightonenglishcenter.edu.co/img/staff-brighton.webp"
            width={1920}
            loading="lazy"
            alt="Convierte el inglés en una herramienta para tu trabajo, agenda un clase de cortecia con nostros."
          />
        </div>
      </div>
    </div>
  );
}

export default CallToAction;
